module.exports = __webpack_public_path__ + "624c1255/img/37000000-8.5c6c3349.png";